import styled from 'styled-components';

const StyledCard = styled.div`
  border: 2px solid ${(props) => props.theme.colors.light} !important;
  margin-bottom: 1rem;
  box-shadow: none !important;
  border-radius: 4px !important;
`;

export default StyledCard;
